<template>
  <div class="shogi-board">
    <h1>{{pageTitle}}</h1>
    <div>
      <button @click="setupGame">ゲーム開始</button>
    </div>
    <div v-if="error" class="alert">
      <ul style="list-style-type:none">
        <li v-for="(msg,index) in errorList" :key="index">
          {{msg}}
        </li>
      </ul> 
    </div>
    <div class="board-area">
      <koma-board :isEnemyBoard="true" :playerSide="enemyPlayerSide"/>
      <div class="board-grid">
          <shogi-cell v-for="(koma,index) in flatLayout"
              :key="index"
              :index="index"
              :boardName="$options.name"
              :img="resolveKomaImg(koma)"
              :komaName="resolveKomaName(koma)"
              :isEnemy="isEnemy(koma)"
              @cellClicked="handleCellClick"
              @cellError="handleCellError">
          </shogi-cell>
      </div>
      <koma-board :isEnemyBoard="false" :playerSide="myPlayerSide" @cellClicked="handleCellClick"/>
    </div>
  </div>
</template>

<script>
import shogiCell from './shogiCell.vue';
const shogiUtil = require('common/shogiUtil');
import {mapState,mapGetters} from 'vuex'
import komaBoard from './komaBoard.vue';
import komaImgResource from './resource';

export default {
  name: 'shogiBoard',
  components: {
    komaBoard,
    shogiCell
  },
  props: {
    pageTitle: String
  },
  data(){
    return {
      myPlayerSide:'1',
      error:false,
      errorList:[]
    }
  },
  computed:{
      enemyPlayerSide:function(){
        return shogiUtil.resolveEnemySide(this.myPlayerSide);
      },
      ...mapState([
        'round',
        'selectedCell',
        'moveableList'
      ]),
      ...mapGetters([
        'flatLayout',
        'boardState'
      ])
  },
  methods:{
      setupGame: function(){
        this.$store.dispatch('setupGame',this.myPlayerSide);
        if(this.myPlayerSide==='2'){
          //盤面をアップデートし、相手の次の手をまつ
          this.$store.dispatch('requestCounterpartyMove',this.boardState);
        }
      },
      resolveKomaImg: function(koma){
        if (koma==="") return "";
        /** 最初の数字（先手後手）を除く */
        const komaAbbre=koma.slice(1);
        return komaImgResource[komaAbbre].resourece;
      },
      resolveKomaName: function(koma){
        return shogiUtil.resolveKomaName(koma);
      },
      isEnemy: function(koma){
        return shogiUtil.isEnemy(koma,this.myPlayerSide);
      },
      handleCellClick: function({clickedCell,promoteKoma}){
        // 自分の駒をクリックする時、選択
        if(clickedCell && clickedCell.isSelf){ 
          // 自分の駒を選択すると、エラーが消える
          this.error=false;
          this.errorList=[];
          // 既に選択された時は除外
          if(this.selectedCell&&this.selectedCell.index===clickedCell.index){        
            this.$store.dispatch('setSelectedCell',null);
              this.showLegalMove(null);
          } else {
            this.$store.dispatch('setSelectedCell',clickedCell);
            this.showLegalMove(clickedCell);
          }
          return;
        }
        
        // 既に駒が選択された時,選択されたセルに移動可能
        if(this.selectedCell!=null && this.moveableList.includes(clickedCell.index)){
          const cellAfterMove=this.moveKoma(clickedCell);
          // Promote cell if promoteKoma flag is true
          if(promoteKoma){
            this.promoteKoma(cellAfterMove);
          }
          this.$store.dispatch('retriveComMove');
        }
      },
      showLegalMove:function(clickedCell){
        if(!clickedCell){
          this.$store.dispatch('setMoveableList',[]);
        }
        this.$store.dispatch('setMoveableList',shogiUtil.calLegalMove(clickedCell,this.boardState,this.myPlayerSide));
        // If the cell clicked is promotable, dispath event
        if(shogiUtil.isPromoable(clickedCell)){
          this.$store.dispatch('setAllMovePromotable',true);
        }
      },
      moveKoma:function(clickedCell){
        const newBoardState=shogiUtil.deepCopyObject(this.boardState);
        newBoardState.playerSide=this.myPlayerSide;
        const currentKomaIncell=shogiUtil.resolveStateString(clickedCell,newBoardState);
        const movedKoma=shogiUtil.resolveStateString(this.selectedCell,newBoardState);
        newBoardState.layout[clickedCell.row][clickedCell.column]=movedKoma;
        // 駒盤の場合は、capturedKomaからそれを削除
        if(this.selectedCell.boardName==='komaBoard'){
          if(newBoardState.playerSide==='1'){
            newBoardState.capturedPlayer2KomaList.splice(this.selectedCell.index,1);
          } else{
            newBoardState.capturedPlayer1KomaList.splice(this.selectedCell.index,1);
          }
        // shogiBoardの場合は、元の位置を''に設定
        } else {
          newBoardState.layout[this.selectedCell.row][this.selectedCell.column]='';
        }
        if(currentKomaIncell!=''){
          if(this.myPlayerSide==='1'){
            newBoardState.capturedPlayer2KomaList.push(currentKomaIncell.replace('2','1'));
          }
          if(this.myplayerSide==='2'){
            newBoardState.capturedPlayer1KomaList.push(currentKomaIncell).replace('1','2');
          }
        }
        // 移動後のCellDomain（「なる」処理用）
        const cellAfterMove=this.selectedCell.clone();
        cellAfterMove.index=clickedCell.index;
        //盤面をアップデート
        this.$store.dispatch('submitMove',newBoardState);
        // 移動後のCellDomainを返す
        return cellAfterMove
      },
      promoteKoma:function(cellDomain){
        this.$store.dispatch('submitMove',shogiUtil.promote(cellDomain,this.boardState));
      },
      handleCellError:function({errorType,msg}){
        this.error=true;
        if(errorType==='illegalPromotionError') {
          msg=`${this.selectedCell.komaName}はここで「なる」ことができない`
        }
        this.errorList.push(msg);
        this.$store.dispatch('setMoveableList',[]);
      }
  }
}
</script>

<style scoped> 
  .board-grid {
    justify-content: center;
    background: url("../assets/shogi-img/board/japanese-chess-b02.jpg");
    background-repeat: no-repeat;
    background-size: auto;
    background-position: center;
    padding: 30px 30px 35px 30px;
    display: inline-grid;
    grid-template-columns: repeat(9, 60px);
    grid-template-rows: repeat(9, 64px);
  }
  .alert {
    background-color: blanchedalmond;
    text-emphasis:palevioletred;
  }
</style>
